import { userService } from 'api/loginServices';
import {
  GET_USER_TYPE_FAILURE,
  GET_USER_TYPE_REQUEST,
  GET_USER_TYPE_SUCCESS
} from 'constants/actionTypes';

export const userType = {
  fetchUserType
};

const mock = {
  message: 'User Type',
  data: {
    userName: 'otmm.hotfolder@OTMMusers',
    userType: 'b2c',
    countryCode: 'us',
    cartId: '1030065702',
    isAnonymous: false,
    firstName: 'Santhosh',
    b2bSessionId: '',
    isCrmManager: true,
    isSosManager: false,
    isB2BMasterUser: false,
    displayType: 'cmgtadmin',
    regStatus: 'Partially Registered',
    lastName: 'Muttennavar',
    userId: 3602194271,
    newCart: true,
    erpType: 'Global_E1',
    lang: 'en',
    isCSR: true,
    site: 'thermofisher.com'
  },
  apiStatus: 'SUCCESS'
};

function fetchUserType() {
  return async (dispatch: any) => {
    dispatch(request(GET_USER_TYPE_REQUEST));
    userService
      .getUserType()
      .then((resp: any) => {
        return resp.json();
      })
      .then((data: any) => {
        console.log('fetchUserType actions', data);
        if (data?.apiStatus?.toLowerCase() === 'success') {
          dispatch(success(GET_USER_TYPE_SUCCESS, data));
        } else {
          dispatch(
            failure(
              GET_USER_TYPE_FAILURE,
              data?.message || 'Error fetching user type'
            )
          );
        }
      })
      .catch((error: any) => {
        dispatch(
          failure(
            GET_USER_TYPE_FAILURE,
            error || 'Error fetching user type'
          )
        );
      });
  };
}

function request(type: string) {
  return { type: type };
}

function success(type: string, data: any) {
  return { type, payload: { data: data } };
}

function failure(type: string, message: string) {
  return { type, payload: { message } };
}
